import styled, {css} from "styled-components";
import {HeaderArenasStyle} from "../../../themes/architecture/sections/theme-layout.interface";

export const HomePageHeaderArenasContainerDefaultBox = styled.div<{headerArenasStyle: HeaderArenasStyle;}>`
  margin-bottom: 4rem;

  text-align: center;
  white-space: nowrap;

  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({headerArenasStyle}) => headerArenasStyle === HeaderArenasStyle.Menu ? css`
    background-color: ${({theme}) => theme.colors.background};
    padding: 1.8rem 0;
  ` : ""}

  @media ${({theme}) => theme.mediaQuery.lAndAbove} {
    overflow-x: hidden;
  }

  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    ${({headerArenasStyle}) => headerArenasStyle === HeaderArenasStyle.Menu ? css`
      margin-right: -4rem;
      margin-left: -4rem;
      padding: 2.2rem 0;
    ` : ""}
  }
`;
